module.exports = __webpack_public_path__ + "img/gaoke_mini.f9bf9536.png";